module.exports = "<h4>Calendar</h4>\r\n\r\n<p-calendar [(ngModel)]=\"value\" [showIcon]=\"true\"></p-calendar>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/calendar/calendar.component.html
// module id = ./src/app/core/calendar/calendar.component.html
// module chunks = 0